import { Controller } from "@hotwired/stimulus"
import { get } from "@github/webauthn-json"

export default class extends Controller {
  static targets = ["button", "status"]
  static values  = { authOptionsUrl: String, authenticateUrl: String }

  async connect() {
    this.abortController = new AbortController()
    if (window.PublicKeyCredential?.isConditionalMediationAvailable) {
      const available = await window.PublicKeyCredential.isConditionalMediationAvailable()
      if (available) this.startConditionalAuth()
    }
  }

  disconnect() {
    this.abortController?.abort()
  }

  async startConditionalAuth() {
    try {
      const options = await this.fetchJson(this.authOptionsUrlValue, "POST")
      const credential = await get({ publicKey: options, mediation: "conditional", signal: this.abortController.signal })
      await this.submitCredential(credential)
    } catch {
      // silent — user cancelled or navigated away
    }
  }

  async authenticate() {
    this.abortController?.abort()
    this.abortController = new AbortController()
    if (this.hasButtonTarget) this.buttonTarget.disabled = true

    try {
      const options = await this.fetchJson(this.authOptionsUrlValue, "POST")
      const credential = await get({ publicKey: options, signal: this.abortController.signal })
      await this.submitCredential(credential)
    } catch (error) {
      if (error.name === "AbortError") return
      this.showError(error.message || "Authentication failed. Please try again.")
      if (this.hasButtonTarget) this.buttonTarget.disabled = false
    }
  }

  async submitCredential(credential) {
    const result = await this.fetchJson(this.authenticateUrlValue, "POST", { credential })
    if (result.redirect_url) {
      window.location.href = result.redirect_url
    } else {
      this.showError(result.error || "Authentication failed.")
      if (this.hasButtonTarget) this.buttonTarget.disabled = false
    }
  }

  showError(message) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.classList.remove("hidden")
    }
  }

  async fetchJson(url, method, body = null) {
    const headers = {
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
    }
    if (body) headers["Content-Type"] = "application/json"

    const response = await fetch(url, {
      method,
      headers,
      body: body ? JSON.stringify(body) : null
    })
    return response.json()
  }
}
